import compose from 'ramda/src/compose'
import path from 'ramda/src/path'
import parse from 'qs/lib/parse'
import tail from 'ramda/src/tail'
import refreshTokenFn from 'root/src/client/logic/auth/thunks/refreshToken'
import authDetermined from 'root/src/client/logic/app/actions/authDetermined'
import { getCookies, setCookie } from 'root/src/client/v2/browser/helpers/cookies'
import getExpirationMinutes from 'root/src/client/logic/auth/util/getExpirationMinutes'
import setSession from 'root/src/client/logic/auth/util/setSession'
import moment from 'moment'
import initRequests from 'root/src/client/logic/app/thunks/initRequests'
import mixpanel from 'root/src/client/logic/analytics/mixpanel'
import decode from 'jwt-decode'
import displayModal from 'root/src/client/logic/modal/actions/displayModal'
import {
	TIKTOK_SET_EMAIL_MODAL_MODULE_ID,
} from 'root/src/shared/descriptions/modules/moduleIds'
import analyticsSendItem from 'root/src/client/logic/analytics/util/analyticsSendItem'
import { events } from 'root/src/shared/constants/analytics'
import stringify from 'qs/lib/stringify'

export const logout = () => {
	setCookie('refreshToken', '', -1)
	setCookie('email', '', -1)
	setCookie('userId', '', -1)
	setCookie('parentUserId', '', -1)
	setCookie('accessToken', '', -1)
	setCookie('groups', '', -1)
	// this one is important for accounts which are
	// federated under other accounts (eg. agency publishers)
	setCookie('backToken', '', -1)
	mixpanel.reset()
} // clean cookies

export const determineAuthHof = authDeterminedFn => ({ forceRefreshSession } = {}) => async dispatch => new Promise(
	async (resolve) => {
		if (!global.window) return undefined
		const hash = compose(parse, tail, path(['location', 'hash']))(window) || {}
		const query = compose(parse, tail, path(['location', 'search']))(window)
		// This needs to be here if we want to clean query string for logout
		if (query) {
			const { logout: logoutProp, fromPanel, isRegistered, platform, userId } = query

			if (isRegistered && JSON.parse(isRegistered)) {
				analyticsSendItem(events.channelConnected[platform], userId)
			}

			if (logoutProp === 'true') {
				// eslint-disable-next-line no-restricted-globals
				history.pushState({}, null, window.location.href.split('?')[0])
			}
			if (fromPanel === 'true') {
				window.close()
			}
		}

		if (hash.accessToken || hash.backToken) {
			// http://localhost:8585/#cognitoGroups%5B0%5D=brand&userId=user-0a6e0411-f35d-4377-a0f7-08951274ed09&refreshToken=eyJjdHkiOiJKV1QiLCJlbmMiOiJBMjU2R0NNIiwiYWxnIjoiUlNBLU9BRVAifQ.OoX5YOd2NSSkecQOlAhS4_tMOeAig5f_C18r866qUg97tPoDOOeQD8_HXETaAs6Nvl8rOdkwfSD8hZ3i3x4cgSfYw5HTQmdSJ1A0gDNejRd8mEcnED8hgxgJ13wGdJ6BdWG1WTqAfL6m493tozKVUZc5qgw-e9kHf1kbgFAsUtxO42eCxAo9UF41232v2-0WX30S07C4HDxHmNr0emf8F-7YvA9SCYl9YmyOcinOU9DXfkwz22jgfvevOgZVfiZLEQkoaWHjoUZ29maCExJXb52tb3fPVCa9zzs3Tkko3vLCxnWDwTaM5dCcPsredrraGv0NJ8HngQ4h1zFjPl38jw.4IvrdU_YYFe8dJNL.dks4cLnnshGHeTk3r4_XZ-E214xKkbwl7g3tPgs86lelac7JGviXvn0Z7WJWtyA4oTwT7_5klJXF6n0sOB6LMbOZD_p5HwNxxcZ6gWPWvay4aO2DKjT-F1ifshgnGbMaKzI-CxfsBiWQrRxI5d-LJ4UWyfdjbwKP4wAsAwL7jC2K8nr2qIGSkqmIcGAclRW82Eq-TLfajGz23mCu83_m4UZjnJoE0gdiCNkwgkqeQjBSZgRpLLGA11TEQSWPZYEBjWzJAFYaFA7CY6hpz99fiFaZSKTGu3je3zbByuvtulbWISe1t0f4O6PXX04BSGL1erZl4UfaknUDUD2tYP2vatLi-FqndlTLMfvkpDNvh6SiuMTgC6zzT4hkBWr-wP-27AI5m7OKwOY62ZDFHootCvS2W673AroTiiETjkBRrDCpKJO70XzJ6Xw8txBCMLgfXiFDb4ZGi6LDqTLDFZvqr9JCdq-ODHAiCufVKbCGiuAj6FEJMCW8bA6tpbBtQS2tCD7z4CV1nwsxIZoa9dkqRRMXkJTU6pXFB1CDYNqMP2MeKdazD1kbQADE9bDoxeDXS3e_343AUQ6B8FN5iPtNrFxmguRuAh7Kv3uevWmdqakJ-4v-K9VhxJIvnAmQLO8kKQM516cV8OqlYjwONdZiv2heG054De3kuX8fbZoWd1A1Do1tCYtjv01D58wQpfhk9tyCtST1Trh-Cf0r5VtD4PJAQW5ST65ICXgBNiFhkMJjXB3ojWJD2AX06hU9BM56phA5gA5kdgWeyXLkm5kjXupJ4m8OXU5BAiqKpkSxqfVU_jFhm4TO9xAJT9D4ggKhMO6JNpAsnpG4-c3z5ND0ywrpHuGLBoRNcqLg7ZBgV55riArbgOEeZjPVbljq_fpTd5U896-W3Ov1SjwzkCoxS6CQZHhcv3ii1kGkdqCJjKKmmP7cXaUN5k5A6R30_KD9KObSmRhsKbucOZFooM6fmS9cUFtdWOYjd6pJhe6WV1YgB8_1-PvOFv4YQYkICC_uUtff86PPFG-IQLTk6mzotrakXAjM4P9yVu3ol0Qdo7cn2Fcjo-g2CvGS47XS5GF5hK5MiACHOCOCPPfv9ZP-Xa0krHZ_gVSAKHfitXqI08TCksDS1pq6QU89pfN5Y1aCa0UfS8mWpBfVcuScvTR6bT6PGy7lWWhlqU-u2I2QGzdsn8PTR2SoYeXQdVMQ7e4DO3PzOh0ZxVKVgFSu-jdAgQOIU_LPuqZfrw.3I5a2yk9xCgJp9xg4aO-qA&idToken=eyJraWQiOiJ5dnhVQlp4amh4MThFQ1pob2RhcU9md0FcL2dkZDRhQUwyV0JJaDdVODhvZz0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJlYzcxYjUxZS04MTU5LTQ3YWMtODIxMi1lYWZmYTMwMGEyNmIiLCJhdWQiOiIxYWkyczFodmFwYjg2MnBtdjAwa204aXVlZSIsImNvZ25pdG86Z3JvdXBzIjpbImFnZW5jeSJdLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwidG9rZW5fdXNlIjoiaWQiLCJhdXRoX3RpbWUiOjE2NDQ1MTAwNzQsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy1lYXN0LTEuYW1hem9uYXdzLmNvbVwvdXMtZWFzdC0xX0hhZ3hvUllCUCIsImNvZ25pdG86dXNlcm5hbWUiOiJlYzcxYjUxZS04MTU5LTQ3YWMtODIxMi1lYWZmYTMwMGEyNmIiLCJleHAiOjE2NDQ1MTM2NzQsImlhdCI6MTY0NDUxMDA3NCwiZW1haWwiOiJwaWVrYXJza2lfZCthZ2VuY3lAbzIucGwifQ.lqiWcvGLAfxNQqhRpebI16G0Bm9AUTbDk-e4qmjblp9zUp9JUUO8IUjsaaqiEdP3knDGYk-OdpEx6oXtpXCOTCxxRH_kaumwIoeB2H9Tusv7K6QRmNLwpVDmWzW9V81XTOMmvHDJfF_chJS1Z1yFORc69--n-rOmrA_b5SM_PoEmnBPuH5_DQbmUZdrKXAz1xPHR7rG8-u8YhLbt_4kJSkLsLUkmkWlJrRSSPzr_g8VrOFUnWPH16X3kw71fKr14YZmk1eTrartVxvf5zQUtOihrJx16GLewv337iOPLRoIZPWbR8P-kDfzJo1avofujnxqr_s2eaZf1yAOr-tPMnA&accessToken=eyJraWQiOiJYc2dTZUlabDdTNlVCNlRLTHQzVHdqS1pcL1U4dG5iREdvOFJcL1VlRUgxRk09IiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiJlYzcxYjUxZS04MTU5LTQ3YWMtODIxMi1lYWZmYTMwMGEyNmIiLCJjb2duaXRvOmdyb3VwcyI6WyJhZ2VuY3kiXSwidG9rZW5fdXNlIjoiYWNjZXNzIiwic2NvcGUiOiJhd3MuY29nbml0by5zaWduaW4udXNlci5hZG1pbiIsImF1dGhfdGltZSI6MTY0NDUxMDA3NCwiaXNzIjoiaHR0cHM6XC9cL2NvZ25pdG8taWRwLnVzLWVhc3QtMS5hbWF6b25hd3MuY29tXC91cy1lYXN0LTFfSGFneG9SWUJQIiwiZXhwIjoxNjQ0NTEzNjc0LCJpYXQiOjE2NDQ1MTAwNzQsImp0aSI6IjUyNGYzY2U1LWQxYmEtNGFjYi05ZTYyLWQzYjBlOTZkNGY5YSIsImNsaWVudF9pZCI6IjFhaTJzMWh2YXBiODYycG12MDBrbThpdWVlIiwidXNlcm5hbWUiOiJlYzcxYjUxZS04MTU5LTQ3YWMtODIxMi1lYWZmYTMwMGEyNmIifQ.u0guZXADaqqT6bBDV7RVafLo2WVIfqyCX9-kPoRdWQ8DrqDkJ1LP1DQ1KmgcBgmPISD2E6bivVnRjW7lZo2mnattKTwzATB4B0PCzagyP57FlCnaEWAHAF0U6lkkbk-pUNiFbjrLZKMoNO8GeiW0Sk8Sbr2BZ3E6qawM7VDrMEINwGgobsmvbjyoSov41Jm9WK3eoudqD31z1sNfuJnFgZ49v_1qGjEliZyBtgJy7lyy6DCgHxY4EHmv_8cTMmeFQLnD0BFXMauZjQCO0oa5OntA3B7_3FuJw4uZ0O3IGflBjMppq-YvrVoZd-PCopo8cvXhaziz3Qo45YwM0YFEJw
			const { accessToken, refreshToken, backToken } = hash
			const { userId, email, groups, parentUserId } = decode(accessToken || backToken) || {}

			if ((accessToken || backToken) && userId && groups && email) {
				const session = {
					...hash,
					email,
					groups: JSON.stringify(Array.isArray(groups)
						? groups : [groups]),
					accessToken: accessToken || backToken,
					refreshToken,
					userId,
					parentUserId,
					accessTokenExp: moment().add(1, 'hours').unix(),
					refreshTokenExp: moment().add(1, 'years').unix(),
				}

				const updatedSearch = {
					isCreatorTransformable: query?.isCreatorTransformable,
				}

				const search = stringify(updatedSearch)

				setSession(session)
				// removes query and hash from url
				// eslint-disable-next-line no-restricted-globals
				history.pushState({}, null,
					`${
						window.location.protocol
					}//${
						window.location.host
					}${
						window.location.pathname
					}${
						search.length ? `?${search}` : ''
					}`)
			}
		}

		const { accessToken, email, refreshToken, userId, parentUserId, groups } = getCookies()

		// TikTok oauth doesn't provide us email, so we have to allow them to set it
		if (email === 'EMAIL_NOT_SET') {
			logout()
			return dispatch(displayModal(TIKTOK_SET_EMAIL_MODAL_MODULE_ID, { token: accessToken }))
		}

		const context = {
			modal: query?.modal,
		}

		if (!accessToken && !refreshToken) {
			return resolve({
				...dispatch(authDeterminedFn()),
				context,
			})
		}

		// dispatch(authDeterminedFn({ accessToken, email, refreshToken, userId, groups }))

		if (forceRefreshSession || getExpirationMinutes(accessToken) <= 10) {
			await dispatch(refreshTokenFn({ refreshToken }, logout, setSession))
			return resolve({ context })
		}

		dispatch(authDeterminedFn({
			accessToken, email, refreshToken, userId, groups, parentUserId,
		}))

		const session = {
			userId,
			parentUserId,
			groups,
			email,
		}

		return resolve({ session, context })
	},
).then(async ({ context }) => {
	// we don't wait for this to be resolved.
	dispatch(initRequests({ context }))

	if (context?.modal) {
		dispatch(displayModal(context.modal))
	}
	// don't add anything depending on state below ()
})

export default determineAuthHof(authDetermined)
